"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const NTP_SERVER_STG = 'https://sso.buildstaging.com/rest/v1/currenttimeserver';
const NTP_SERVER_PROD = 'https://sso.hotmart.com/rest/v1/currenttimeserver';
class NtpService {
  constructor(isProd) {
    this.url = isProd ? NTP_SERVER_PROD : NTP_SERVER_STG;
  }
  getEpochTime() {
    return __awaiter(this, void 0, void 0, function* () {
      const localTime = Date.now() / 1000 | 0; // Current date in seconds.
      try {
        const response = yield fetch(this.url);
        const time = yield response.json();
        const serverTime = +new Date(time) / 1000 | 0;
        const diff = serverTime - localTime;
        return Promise.resolve(localTime + diff);
      } catch (e) {
        console.error('[NTP]', e);
        return Promise.resolve(localTime);
      }
    });
  }
}
exports.default = NtpService;